import FrameBorder from "@/component/FrameBorder";
import ReachedMilestones from "@/component/popups/ui-4/ReachedMilestones";
import {
  getStreakStatus,
  postLoginStreakClaim
} from "@/Redux/futures/shweJourney/actions";
import claimBtnImg from "@assets/web-v3-images/Claim-btn.png";
import claimBtnImgMaster from "@assets/web-v3-images/Claim-btn-master.png";
import LbImg from "@assets/web-v3-images/coin.png";
import coinsImg from "@assets/web-v3-images/icons/shwe-hour-coin.png";
import puzzleImg from "@assets/web-v3-images/icons/puzzlex5.png";
import HeartImg from "@assets/web-v3-images/icons/Heart.png";
import reviewItemsImg from "@assets/web-v3-images/image.png";
import TicketImg from "@assets/web-v3-images/icons/turnto.png";
import backgroundImg from "@assets/web-v3-images/FrameBorder.png";
import { Text } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import ProgressDay from "../ProgressDay";
import { toast } from 'react-toastify';

export default function EventDays({ data }) {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch();
  const [openPurchaseSuccess, setOpenPurchaseSuccess] = useState(false);
  const [dataClaim, setDataClaim] = useState();
  const [todayReward, setTodayReward] = useState({});

  useEffect(() => {
    if (data?.today_reward?.length) {
      setTodayReward(data.today_reward[0]);
    }
  }, [data]);

  const callbackClaim = (data, isLoading, dataError) => {
    if (isLoading) return;
    if (dataError?.showType === 2) {
      toast.error(dataError.errorMessage);
      return;
    }

    if (data) {
      setOpenPurchaseSuccess(true);
      setDataClaim(data);
      setTodayReward((prev) => ({
        ...prev,
        reward_amount: data?.data?.rewards?.[0]?.reward_amount,
      }));
      dispatch(getStreakStatus({}));
    }
  };

  const handleClaim = () => {
    const body = {
      callback: callbackClaim,
    };
    dispatch(postLoginStreakClaim(body));
  };

  const REWARD_ICON_MAP = {
    COIN: coinsImg,
    TURN: puzzleImg,
    LP: LbImg,
    MAGIC_WHEEL_HEART: HeartImg,
    MATHMATCH_TICKET: TicketImg,
    REVIVE_ITEM: reviewItemsImg
  };

  const DEFAULT_REWARD_ICON = coinsImg;

  function getRewardIcon(rewardType) {
    return REWARD_ICON_MAP[rewardType] ?? DEFAULT_REWARD_ICON;
  }

  const rewardIcon = getRewardIcon(todayReward?.reward_type);

  return (
    <>
      <FrameBorder>
        <div
          className="w-full bg-cover bg-no-repeat sm:py-3"
          style={{
            backgroundImage: `url(${backgroundImg})`,
            backgroundSize: "100% auto",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top center",
          }}
        >
          <ProgressDay data={data} />
          <div className="py-2 sm:py-3 md:py-5 lg:py-5 xl:py-5">
            <div
              className="
						 grid grid-cols-[2fr_1fr] gap-2 sm:gap-3
						bg-[rgba(255,206,150,1)]
						py-[10px] sm:py-[20px] 
						px-[7px] sm:px-[7px] md:px-[7px] lg:px-[30px] xl:px-[30px]
						mx-[10px] sm:mx-[10px] md:mx-[10px] lg:mx-[20px] xl:mx-[20px]
						rounded-[30px]
						shadow-[inset_0_3px_0_rgba(239,168,121,1),0_-1px_4px_rgba(255,255,255,1)]
					"
            >
              {/* Cột trái */}
              <div className="flex items-center gap-1 sm:gap-2 min-w-0">
                <img
                  src={rewardIcon}
                  alt="coin"
                  className="h-12 sm:h-22 w-auto flex-shrink-0"
                />
                <div className="flex flex-col items-start">
                  <Text className="text-xs sm:text-xs md:text-2xl lg:text-2xl xl:text-2xl text-[#A15C07] font-medium">
                    {t("shwe_journey.today_reward")}
                  </Text>

                  <Text
                    className="
										text-[16px]
                    sm:text-3xl
										font-semibold
										text-[#713B12]
									"
                  >
                    {todayReward?.reward_amount} {todayReward?.reward_name}
                  </Text>
                </div>
              </div>

              {/* Cột phải */}
              <div className="flex items-center justify-end">
                <button
                  onClick={handleClaim}
                  className={`
										   w-25 
											 sm:w-45
										bg-contain
										bg-center
										h-full
										bg-no-repeat
										cursor-pointer
										btn-click-active
										${data?.today_claimed || data?.day_off !== 0
                      ? "opacity-30 cursor-not-allowed pointer-events-none"
                      : "cursor-pointer btn-click-active"
                    }
										`}
                  style={{
                    backgroundImage: `url(${data?.rank === 'MASTER' ? claimBtnImgMaster : claimBtnImg})`,
                  }}
                >
                  <Text
                    as="span"
                    className={`
                      select-none
										text-white
										font-semibold
										uppercase
                    ${i18n.language === 'en' ? "text-[16px] sm:text-[28px]" : "text-[10px] sm:text-[18px]"}
                      `}
                    style={{
                      WebkitTextStroke: "4px #D86B00",
                      paintOrder: "stroke fill",
                    }}
                  >
                    {data?.today_claimed ? t("shwe_journey.claimed") : t("shwe_journey.claim")}
                  </Text>
                </button>
              </div>
            </div>
          </div>
        </div>
      </FrameBorder>
      <ReachedMilestones
        open={openPurchaseSuccess}
        onOpenChange={setOpenPurchaseSuccess}
        textBtn={t("shwe_journey.claim_reward")}
        handleClick={() => setOpenPurchaseSuccess(false)}
        rewardAmount={dataClaim?.data?.rewards?.[0]?.reward_amount}
        currentStreak={dataClaim?.data?.current_streak}
        image={rewardIcon}
      />
    </>
  );
}
